import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { View } from 'react-native';
import { BiSurfaceCard } from '../../components/ui/BiSurfaceCard';

/** A titled card of the dataset page. */
export const DetailSection = memo(
  ({
    title,
    trailing,
    children,
  }: {
    title: string;
    trailing?: ReactNode;
    children: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <BiSurfaceCard style={{ padding: rpx(16), gap: rpx(12) }}>
        <View
          style={{ flexDirection: 'row', alignItems: 'center', gap: rpx(8) }}
        >
          <Typography.Text
            medium
            size={rpx(14)}
            color={aiColors.foreground}
            style={{ flex: 1 }}
          >
            {title}
          </Typography.Text>
          {trailing}
        </View>
        {children}
      </BiSurfaceCard>
    );
  },
);
